import type { EffectiveRole } from '@domain/entities';
import type { IAccessRepository } from '@domain/repositories';

export class GetUserRolesUseCase {
  constructor(private readonly accessRepository: IAccessRepository) {}

  async execute(userId: string): Promise<EffectiveRole[]> {
    return this.accessRepository.rolesOfUser(userId);
  }
}
